document.addEventListener( 'DOMContentLoaded', () => {
	// A helper function to toggle the body class based on whether the overlay exists.
	const toggleBodyClass = () => {
		const overlay = document.querySelector( '.betterdocs-modal-overlay' );
		if ( overlay ) {
			document.body.classList.add( 'betterdocs-modal-overlay-open' );
		} else {
			document.body.classList.remove( 'betterdocs-modal-overlay-open' );
		}
	};

	// Run once initially in case the modal is already present.
	toggleBodyClass();

	// Set up the MutationObserver to watch for changes in the DOM.
	const observer = new MutationObserver( () => {
		// Each time the DOM changes, check if the modal overlay is present.
		toggleBodyClass();
	} );

	// Start observing changes to the document.body (and all its descendants).
	observer.observe( document.body, { childList: true, subtree: true } );
} );
